import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {Partner} from "../partner.model";
import {PartnerBanner} from "../partner-banner.model";

export class PartnerBannerDgSearchResults extends GenericDgSearchResults {
  public results: PartnerBanner[];

  constructor(total: number, results: PartnerBanner[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}
